import React, { ChangeEvent, Component } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { Annotation, AnnotationSharedWith } from '@paragon/contract-library';

import AnnotationOptionsSection from './AnnotationOptionsSection';

interface Props {
  readonly annotationBeingEdited: Annotation | undefined;
  readonly enqueueWarning: (warning: string) => void;
  readonly isPlacingText: boolean;
  readonly currentUserEmail: string;
}

interface State {
  readonly sharedWith: AnnotationSharedWith;
}

export const isAnnotationShareable = (annotation: Annotation) =>
  !(annotation.category === 'seal' || annotation.category === 'signature');

export default class SharingOptions extends Component<Props, State> {
  state: State = {
    sharedWith: this.props.annotationBeingEdited
      ? this.props.annotationBeingEdited.sharedWith || 'owner'
      : this.props.isPlacingText || isAnnotationShareable(this.props.annotationBeingEdited!)
        ? 'organization'
        : 'owner',
  };

  onToggleSharedWithOrganization = (event: ChangeEvent<HTMLInputElement>) => {
    if (!this.canModifyAnnotationPermissions) {
      this.props.enqueueWarning('You can only unshare an annotation that you created');
      return;
    }

    if (event.target.checked) {
      this.setState({ sharedWith: 'organization' });
    } else {
      this.setState({ sharedWith: 'owner' });
    }
  };

  get canModifyAnnotationPermissions() {
    return this.props.isPlacingText || this.props.annotationBeingEdited!.creatorEmail === this.props.currentUserEmail;
  }

  get updatedProperties() {
    return {
      sharedWith: this.state.sharedWith,
    };
  }

  render() {
    return (
      <AnnotationOptionsSection title="sharing">
        <FormControlLabel
          control={
            <Checkbox
              color="default"
              id="allow-org-edit"
              checked={this.state.sharedWith === 'organization'}
              disabled={!this.canModifyAnnotationPermissions}
              onChange={this.onToggleSharedWithOrganization}
            />
          }
          label="Allow users in my organization to edit this annotation"
        />
      </AnnotationOptionsSection>
    );
  }
}
